import type {
  PlacementHistoryListResponse,
  PlacementImportStatusResponse,
} from './schemas.js';

export const PLACEMENT_IMPORT_HISTORY_LIST_RESPONSE: PlacementHistoryListResponse =
  {
    data: {
      items: [
        {
          id: '01',
          firstName: 'Matthew',
          lastName: 'McFly',
          status: 'completed',
          fileName:
            'Fiat_Italy_2026_500_Hybrid-January-ChannelVideo-PlatformFiat-Media-R-L-M-Row2-2026.xlsx',
          createdAt: '2026-09-03T14:30:00Z',
        },
        {
          id: '02',
          firstName: 'Matthew',
          lastName: 'McFly',
          status: 'failed',
          fileName: 'Fiat_Italy_2024_500L.xlsx',
          createdAt: '2026-09-02T14:30:00Z',
        },
        {
          id: '03',
          firstName: 'Chris',
          lastName: 'Urbans',
          status: 'completed_with_errors',
          fileName: 'Fiat_Italy_2025_Activity.xlsx',
          createdAt: '2026-09-01T14:30:00Z',
        },
      ],
      message: null,
      pageNumber: null,
      itemsPerPage: null,
      totalItems: 3,
      ordering: null,
      additional: null,
    },
    error: null,
  };

export const PLACEMENT_IMPORT_STATUS_RESPONSE: PlacementImportStatusResponse = {
  data: {
    items: [
      {
        lastItemId: '001',
        lastItemStatus: 'completed',
        fileName: 'Fiat_Italy_2025_Placement_Folders.xlsx',
        fileSize: '2000000',
      },
    ],
    message: null,
    pageNumber: null,
    itemsPerPage: null,
    totalItems: 3,
    ordering: null,
    additional: null,
  },
  error: null,
};
